import { Review } from "@filmweb/sanity-types/dist";
import styles from "./DiceRatings.module.css";
import Link from "next/link";
import { ReactNode } from "react";
import LinkSvg from "components/film/LinkSvg";
import DiceValueSvg from "components/film/DiceValueSvg";

//#region [Props]
type DiceRatingsProps = {
    diceRatings?: Review[];
};
//#endregion

//#region [Component]
export default function DiceRatings({ diceRatings }: DiceRatingsProps) {
    if ((diceRatings?.length ?? 0) === 0) {
        return null;
    }
    return <div className={styles.ReviewsContainer}>
        {diceRatings?.map(dice => {
            const valueNum: number = Number(dice.diceValue);
            if (!Number.isNaN(valueNum) && valueNum < 4) {
                return null;
            }

            let CustomValueIcon: ReactNode;
            if (Number.isNaN(valueNum)) {
                if (dice.diceValue === "0/0") {
                    CustomValueIcon = <LinkSvg />
                } else {
                    CustomValueIcon = <div className={styles.SCustomRatingsValue}>{dice.diceValue}</div>;
                }
            }

            return <Link href={dice.reviewUrl} target="_blank" key={dice._key} className={styles.Review}>
                <div>
                    {!Number.isNaN(valueNum) ? <DiceValueSvg value={valueNum} /> : CustomValueIcon}
                </div>
                <div>
                    <div className={styles.SDiceText}>
                        {dice.who}
                    </div>
                </div>
            </Link>
        })}
    </div>

}
//#endregion